import { render, staticRenderFns } from "./VDialogPin.vue?vue&type=template&id=16b42b79&scoped=true"
import script from "./VDialogPin.vue?vue&type=script&lang=js"
export * from "./VDialogPin.vue?vue&type=script&lang=js"
import style0 from "./VDialogPin.vue?vue&type=style&index=0&id=16b42b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b42b79",
  null
  
)

export default component.exports